/** Viewer color-theme persistence (localStorage). */

const THEME_STORAGE_KEY = "viewer-theme";
const LEGACY_PALETTE_STORAGE_KEY = "viewer-palette";

export type ViewerThemeId = "light" | "dark";

interface ViewerThemeDef {
  label: string;
}

export const VIEWER_THEMES: Record<ViewerThemeId, ViewerThemeDef> = {
  dark: { label: "Тёмная" },
  light: { label: "Светлая" },
};

function migrateLegacyPalette(): ViewerThemeId | null {
  const legacy = localStorage.getItem(LEGACY_PALETTE_STORAGE_KEY);
  if (legacy === "light") return "light";
  if (legacy === "warm" || legacy === "slate") return "dark";
  return null;
}

export function getViewerTheme(): ViewerThemeId {
  const saved = localStorage.getItem(THEME_STORAGE_KEY);
  if (saved === "light" || saved === "dark") return saved;
  return migrateLegacyPalette() ?? "dark";
}

export function getViewerThemeLabel(id: string): string {
  return VIEWER_THEMES[id as ViewerThemeId]?.label ?? VIEWER_THEMES.dark.label;
}

export function applyViewerTheme(id: string): ViewerThemeId {
  const theme: ViewerThemeId = id === "light" ? "light" : "dark";
  document.documentElement.dataset.theme = theme;
  localStorage.setItem(THEME_STORAGE_KEY, theme);
  return theme;
}

export function restoreViewerTheme(): ViewerThemeId {
  return applyViewerTheme(getViewerTheme());
}
